export const LoginDetailLang = {
    username: 'نام کاربری',
    pass: 'پسورد',
    changePass: 'تغییر رمز عبور',
    save: 'ذخیره',
    success: 'اطلاعات شما با موفقیت بروزرسانی شد',
    error: 'خطایی رخ داده است، مجددا تلاش کنید',
};
